import {Theme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    '& > div': {
      marginLeft: '2px',
    }
  },
  formControl: {
    minWidth: 70,
  },
  totalRes: {
    flex: 'none',
    textAlign: 'right'
  },
  summaryBox: {
  minWidth: 220,
  padding: '10px 13px',
  background: '#f9f9f9',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  marginLeft: '10px',
  fontSize: '14px',

  "& .summary-item": {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: 4,
  },

  "& .summary-item:last-child": {
    borderBottom: 'none',
  },

  "& .label": {
    color: '#666',
    fontWeight: 500,
  },

  "& .value": {
    fontWeight: 600,
    color: '#111',
  }
}
}))
